import { initials } from '@/lib/utils';
import { cn } from '@/lib/utils';

interface Props {
  name: string;
  color?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  src?: string;
}

const sizes = {
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-10 w-10 text-xs',
  lg: 'h-14 w-14 text-sm',
  xl: 'h-20 w-20 text-2xl',
};

/**
 * Avatar — renders an image when present, otherwise a flat warm colour
 * with initials (aplat, jamais de dégradé — refonte design). The colour
 * comes from the per-client data so each user keeps a stable visual
 * identity.
 */
export function Avatar({ name, color = '#F97316', size = 'md', className, src }: Props) {
  if (src) {
    return (
      <img
        src={src}
        alt={name}
        className={cn(
          'rounded-full object-cover',
          sizes[size],
          className,
        )}
      />
    );
  }
  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center rounded-full font-bold text-white',
        sizes[size],
        className,
      )}
      style={{ background: color }}
      aria-label={name}
    >
      {initials(name)}
    </div>
  );
}
